import React from 'react'
import Header from '../../Components/Header/header';
import Card from '../../Components/Card/card';
import Data from '../../Components/App/Data';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './About.css';

const chefData = [
  {
      url: '/images/2chef.jpg',
      caption: 'About Us',
  }
]

const clientData = [
  {
    image: 'client-photo.jpg',
    title: 'Sonia Smith',
    description: 'Praesent dapibus, neque id cursus faucibus, tortor neque egestas Praesent dapibus, neque id cursus faucibus, tortor neque egestas.',
  },
  {
    image: 'client-photo2.jpg',
    title: 'John Smith',
    description: 'Praesent dapibus, neque id cursus faucibus, tortor neque egestas Praesent dapibus, neque id cursus faucibus, tortor neque egestas.',
  }
]


const divStyle = {
  width: '100%',
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '510px',
  backgroundSize: 'cover',
  marginBottom: '60px',
  marginTop: '5px',
}

const spanStyle = {
  fontFamily: 'Marck Script',
  fontSize: '40px',
  color: '#ffffff',
  fontStyle: 'italic',
}
export default function About() {

  

  const cards = Data.map(item => {
    return (
      <Card 
      key={item.id}
      {...item}
      />
    )
  })

  return (
    <div className='about'>
      <Header />
        {chefData.map((image, index) =>(
          <div key={index}>
             <div style={{...divStyle, backgroundImage: `url(${image.url})`}}>
          <span className="topLevel" style={{...spanStyle}}>{image.caption}</span>
        </div>
        </div>
        ))}
       
       {/* <img src='/images/2chef.jpg' alt='chef-pics-icon' className='chef-pics-icon' />
        <span className='chef-text'>About Us</span>*/}
        <div className='about-header'>
          <h4 className='about-text'>Our History</h4>
          <p className='pText'>
             Proin facilisis varius nunc. 
             Curabitur eros risus, ultrices et dui ut, 
             luctus accumsan nibh. Fusce convallis sapien
             placerat tellus suscipit vehicula.
             Cras vitae diam ut justo elementum 
             faucibus eget a diam. Etiam sodales a sem 
             vitae fermentum. Curabitur pellentesque
          </p>
          <div className="restaurant-container">
            <img src='/images/restaurant.jpg' alt='restaurant' className='restaurant' />
          </div>
        </div>
        <div className="wrap-card">
            <h4 className='about-text2'>Meet Our Team</h4>
         <div className="container-card">
          {cards}
         </div>
       </div>
       <h3 className="client-title">Clients Review</h3>
       <div className="container-client">  
       {clientData.map((clients, index) =>(
          <div key={index} className="client-review">
          <div className="client-combo">
             <img className="client-pic" src={`../images/${clients.image}`} alt='client-photo' />
             <div className="client-description">
             <h4 className="client-name">{clients.title}</h4>
             <p className='client-text'>
             {clients.description}
             </p>
          </div>
          </div>
        </div>
       ))}
       </div>
       <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>
  )
}
